'use client';

import React from 'react';

interface PaymentLinksModalProps {
  onClose: () => void;
}

// Stripe Payment Links — update these URLs with your actual Stripe payment links
// $1 link → redirects to ?view=paid after payment
// $5 link → redirects to ?view=paidall after payment
const STRIPE_LINK_1 = 'https://buy.stripe.com/test_placeholder_1dollar';
const STRIPE_LINK_5 = 'https://buy.stripe.com/test_placeholder_5dollar';

export default function PaymentLinksModal({ onClose }: PaymentLinksModalProps) {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://surfsterre6919.builtwithrocket.new';

  const handlePay1 = () => {
    const link = `${STRIPE_LINK_1}?success_url=${encodeURIComponent(siteUrl + '/run-scene?view=paid')}&cancel_url=${encodeURIComponent(siteUrl + '/run-scene')}`;
    window.location.href = link;
  };

  const handlePay5 = () => {
    const link = `${STRIPE_LINK_5}?success_url=${encodeURIComponent(siteUrl + '/run-scene?view=paidall')}&cancel_url=${encodeURIComponent(siteUrl + '/run-scene')}`;
    window.location.href = link;
  };

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0"
        style={{ background: 'rgba(13,13,15,0.88)', backdropFilter: 'blur(12px)' }}
        onClick={onClose}
      />

      {/* Card */}
      <div
        className="relative w-full max-w-xs mx-4"
        style={{
          background: 'linear-gradient(180deg, rgba(20,20,30,0.99) 0%, rgba(13,13,15,0.99) 100%)',
          border: '1px solid rgba(0,229,255,0.22)',
          borderRadius: 24,
          padding: '28px 22px 32px',
          boxShadow: '0 24px 64px rgba(0,0,0,0.7)',
        }}
      >
        {/* Close */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 14,
            right: 14,
            background: 'rgba(255,255,255,0.08)',
            border: 'none',
            borderRadius: '50%',
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: '#8899aa',
            fontSize: 16,
          }}
        >
          ✕
        </button>

        {/* Trophy */}
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 52, lineHeight: 1 }}>🏆</div>
          <h2 style={{
            fontFamily: 'DM Sans, sans-serif',
            fontWeight: 900,
            fontSize: '1.4rem',
            color: '#ffd60a',
            marginTop: 10,
            marginBottom: 4,
          }}>
            You Crushed It!
          </h2>
          <p style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: 13,
            color: '#8899aa',
            lineHeight: 1.5,
          }}>
            Unlock more levels &amp; outfits.<br />
            Choose any — only <strong style={{ color: '#fff' }}>$1</strong>. No login. No storage.
          </p>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'rgba(255,255,255,0.08)', margin: '16px 0' }} />

        {/* Option 1 — $1 */}
        <button
          onClick={handlePay1}
          style={{
            width: '100%',
            padding: '14px 16px',
            borderRadius: 14,
            background: 'linear-gradient(135deg, #00e5ff 0%, #0077ff 100%)',
            border: 'none',
            color: '#0d0d0f',
            fontFamily: 'DM Sans, sans-serif',
            fontWeight: 800,
            fontSize: 15,
            cursor: 'pointer',
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span>🎮 Unlock Any 1 Level or Outfit</span>
          <span style={{
            background: 'rgba(0,0,0,0.18)',
            borderRadius: 8,
            padding: '3px 10px',
            fontSize: 14,
            fontWeight: 900,
          }}>$1</span>
        </button>

        {/* Option 2 — $5 */}
        <button
          onClick={handlePay5}
          style={{
            width: '100%',
            padding: '14px 16px',
            borderRadius: 14,
            background: 'linear-gradient(135deg, #ffd60a 0%, #ff9f43 100%)',
            border: 'none',
            color: '#0d0d0f',
            fontFamily: 'DM Sans, sans-serif',
            fontWeight: 800,
            fontSize: 15,
            cursor: 'pointer',
            marginBottom: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span>✨ Unlock Everything</span>
          <span style={{
            background: 'rgba(0,0,0,0.18)',
            borderRadius: 8,
            padding: '3px 10px',
            fontSize: 14,
            fontWeight: 900,
          }}>$5</span>
        </button>

        {/* Trust badge */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
          opacity: 0.55,
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8899aa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: 10, color: '#8899aa' }}>
            Secure payment via Stripe · One-time · No login required
          </span>
        </div>
      </div>
    </div>
  );
}
